import { BASE_URL } from "../BaseUrl.js";
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("momo4scoohclient");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    config.headers.Authorization = null;
  }

  const codeEntite = localStorage.getItem("entiteSchoolCode");
  if (codeEntite) {
    config.headers["ref_entity"] = `client_${codeEntite}`;
  } else {
    config.headers["ref_entity"] = null;
  }

  // const sousEntiteId = localStorage.getItem("sousEntiteId")
  // if (sousEntiteId) {
  //   config.headers['etablissementId'] = `${sousEntiteId}`;
  // } else {
  //   config.headers['etablissementId'] =  null;
  // }

  return config;
});

const customHeader = {
  etablissementId: localStorage.getItem("sousEntiteId")
    ? localStorage.getItem("sousEntiteId")
    : null,
};

export const getListeNiveauEtudePagination = async (page, size, param = "") => {
  return await axios.get(
    BASE_URL(
      `etablissement/listeniveaux/paginate?page=${page}&param=${param}&size=${size}`
    ),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const getListeNiveauEtude = async () => {
  return await axios.get(BASE_URL(`etablissement/listeniveaux`), {
    headers: Object.assign({}, axios.defaults.headers.common, customHeader),
  });
};

export const ajoutNiveauEtude = async (values) => {
  return await axios.post(BASE_URL("etablissement/enregistrerniveau"), values, {
    headers: Object.assign({}, axios.defaults.headers.common, customHeader),
  });
};

export const deleteNiveauEtude = async (id) => {
  return await axios.delete(BASE_URL(`etablissement/supprimerniveau/${id}`), {
    headers: Object.assign({}, axios.defaults.headers.common, customHeader),
  });
};
